import '@fontsource-variable/inter'
import '@fontsource-variable/roboto-mono'
import './index.css'
import { render } from 'solid-js/web'
import { App } from './App'
import { iniciarTema } from './tema/tema'
import { iniciarPwa } from './pwa'

// Atributos que o CSS do Macro espera no <html> (toque, modalidade de entrada).
const raiz = document.documentElement
raiz.dataset.touchDevice = String(matchMedia('(pointer: coarse)').matches)
for (const [ev, modo] of [['keydown', 'keyboard'], ['pointerdown', 'pointer']] as const) {
  window.addEventListener(ev, () => (raiz.dataset.modality = modo), { capture: true, passive: true })
}

iniciarTema()
iniciarPwa()
render(() => <App />, document.getElementById('root')!)
